/* Pond liner calculator (homepage v2, 2026-10-02) */
(function () {
  var FT = 0.3048;
  var ORDER = ['EPDM', 'Butyl', 'HDPE', 'LDPE', 'PVC', 'Polyex', 'Kit'];
  var cache = {};

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { return index(d.products || []); });
    }
    return cache[handle];
  }

  function material(p) {
    var t = (p.title + ' ' + p.product_type).toLowerCase();
    if (/underlay/.test(t) && !/bundle|kit/.test(t)) return 'Underlay';
    if (/bundle|kit/.test(t)) return 'Kit';
    if (/polyex/.test(t)) return 'Polyex';
    if (/epdm/.test(t)) return 'EPDM';
    if (/butyl/.test(t)) return 'Butyl';
    if (/hdpe/.test(t)) return 'HDPE';
    if (/ldpe/.test(t)) return 'LDPE';
    if (/pvc/.test(t)) return 'PVC';
    return 'Liner';
  }

  function kitMaterial(p) {
    var t = p.title.toLowerCase();
    if (/epdm/.test(t)) return 'EPDM';
    if (/butyl/.test(t)) return 'Butyl';
    if (/ldpe/.test(t)) return 'LDPE';
    if (/hdpe/.test(t)) return 'HDPE';
    return '';
  }

  function guarantee(title) {
    if (/lifetime/i.test(title)) return 'Lifetime guarantee';
    var m = title.match(/(\d+)(?:\s*[-–&,]\s*\d+)*\s*year/i);
    return m ? m[0].replace(/\s+/g, ' ') + ' guarantee' : '';
  }

  function thickness(title) {
    var m = title.match(/(\d+(?:\.\d+)?)\s*mm/i);
    return m ? m[1] + 'mm' : '';
  }

  function dims(s) {
    var m = String(s || '').match(/(\d+(?:\.\d+)?)\s*m?\s*[x×]\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { a: Math.max(a, b), b: Math.min(a, b) };
  }

  function index(products) {
    var items = [];
    products.forEach(function (p) {
      var mat = material(p);
      var sizePos = 1, underlayPos = 0;
      (p.options || []).forEach(function (o, i) {
        if (/size/i.test(o.name)) sizePos = i + 1;
        if (/underlay/i.test(o.name)) underlayPos = i + 1;
      });
      (p.variants || []).forEach(function (v) {
        if (!v.available) return;
        var dm = dims(v['option' + sizePos]);
        if (!dm) return;
        var withUnderlay = underlayPos ? /^with\b/i.test(v['option' + underlayPos] || '') : false;
        items.push({
          mat: mat,
          kitMat: mat === 'Kit' ? kitMaterial(p) : '',
          title: p.title.split(/[|–—]/)[0].trim(),
          full: p.title,
          handle: p.handle,
          id: v.id,
          label: v.title,
          a: dm.a,
          b: dm.b,
          price: parseFloat(v.price),
          was: v.compare_at_price ? parseFloat(v.compare_at_price) : 0,
          underlay: withUnderlay
        });
      });
    });
    return items;
  }

  function money(n) {
    return '£' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fmt(m, unit) {
    if (unit === 'ft') return (m / FT).toFixed(1) + 'ft';
    return (Math.round(m * 100) / 100).toFixed(2).replace(/\.?0+$/, '') + 'm';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function init(root) {
    var form = root.querySelector('form');
    var out = root.querySelector('[data-out]');
    var err = root.querySelector('[data-err]');
    var unit = 'm';
    var handle = root.getAttribute('data-collection') || 'pond-liners';

    root.querySelectorAll('[data-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-unit');
        if (next === unit) return;
        ['l', 'w', 'd'].forEach(function (n) {
          var inp = form.elements[n];
          if (inp.value) {
            var v = parseFloat(inp.value);
            inp.value = next === 'ft' ? (v / FT).toFixed(1) : (v * FT).toFixed(2);
          }
        });
        unit = next;
        root.querySelectorAll('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        root.querySelectorAll('[data-u]').forEach(function (i) { i.textContent = unit; });
        form.elements.l.placeholder = unit === 'ft' ? '10' : '3';
        form.elements.w.placeholder = unit === 'ft' ? '6.5' : '2';
        form.elements.d.placeholder = unit === 'ft' ? '2' : '0.6';
        if (out.classList.contains('is-on')) run();
      });
    });

    // Start loading the catalogue as soon as someone shows intent.
    form.addEventListener('focusin', function () { load(handle).catch(function () {}); }, { once: true });

    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });

    function run() {
      var k = unit === 'ft' ? FT : 1;
      var L = parseFloat(form.elements.l.value) * k;
      var W = parseFloat(form.elements.w.value) * k;
      var D = parseFloat(form.elements.d.value) * k;
      var O = parseFloat(form.elements.o.value);
      err.classList.remove('is-on');
      if (!(L > 0) || !(W > 0) || !(D > 0)) {
        err.textContent = 'Please enter the length, width and maximum depth of your pond.';
        err.classList.add('is-on');
        return;
      }
      if (D > Math.min(L, W)) {
        err.textContent = 'The depth looks larger than the pond width. Please check your measurements.';
        err.classList.add('is-on');
        return;
      }
      var needA = Math.max(L, W) + 2 * D + 2 * O;
      var needB = Math.min(L, W) + 2 * D + 2 * O;
      var area = needA * needB;
      var litres = Math.round(L * W * D * 1000);

      out.classList.add('is-on');
      out.innerHTML = head(needA, needB, area, litres) + '<p class="plx-calc__msg">Checking our liner sizes…</p>';

      load(handle).then(function (items) {
        var best = {};
        var underlay = null;
        items.forEach(function (it) {
          if (it.a + 1e-6 < needA || it.b + 1e-6 < needB) return;
          if (it.mat === 'Underlay') {
            if (!underlay || it.price < underlay.price) underlay = it;
            return;
          }
          if (it.underlay) return; // compare liner-only prices; underlay shown separately
          var key = it.mat;
          if (!best[key] || it.price < best[key].price || (it.price === best[key].price && it.a * it.b < best[key].a * best[key].b)) best[key] = it;
        });
        var rows = ORDER.filter(function (m) { return best[m]; }).map(function (m) { return best[m]; });
        if (!rows.length) {
          out.innerHTML = head(needA, needB, area, litres) +
            '<p class="plx-calc__msg">That is larger than our listed sizes. Call <a href="tel:+441282270214">01282 270214</a> or <a href="https://wa.me/447822012977" target="_blank" rel="noopener">WhatsApp us</a> your measurements and we\'ll tell you what we can supply.</p>';
          return;
        }
        var cheapest = rows.reduce(function (a, b) { return b.price < a.price ? b : a; });
        var html = '<ul class="plx-calc__list">' + rows.map(function (it) {
          var label = it.label.replace(/\s*\/\s*Without Underlay/i, '');
          var g = guarantee(it.full);
          var lg = label.match(/\s*\/\s*(\d+\s*Year)/i);
          if (lg) { g = lg[1] + ' guarantee'; label = label.replace(lg[0], ''); }
          var t = thickness(it.full);
          var sub = [label, t, g].filter(Boolean).join(' · ');
          var matLabel = it.mat === 'Kit' ? (it.kitMat ? it.kitMat + ' kit' : 'Kit') : it.mat;
          return '<li><a class="plx-calc__row" href="/products/' + it.handle + '?variant=' + it.id + '">' +
            '<span class="plx-calc__mat' + (it.mat === 'Kit' ? ' plx-calc__mat--kit' : '') + '">' + esc(matLabel) + '</span>' +
            '<span class="plx-calc__info"><b>' + esc(it.title) + (it === cheapest ? '<span class="plx-calc__best">Lowest price</span>' : '') + '</b><span>' + esc(sub) + '</span></span>' +
            '<span class="plx-calc__price">' + (it.was > it.price ? '<s>' + money(it.was) + '</s>' : '') + money(it.price) + '</span>' +
            '</a></li>';
        }).join('') + '</ul>';
        var note = '<p class="plx-calc__note">Showing the lowest-priced stock size that covers your pond for each liner type. Liners are cut to size, so measure twice and always size up, never down. ';
        if (underlay) {
          note += 'Protect it with <a href="/products/' + underlay.handle + '?variant=' + underlay.id + '">' + esc(underlay.label) + ' underlay (' + money(underlay.price) + ')</a>. ';
        }
        note += 'Unsure? <a href="https://wa.me/447822012977?text=' + encodeURIComponent('Hi, my pond is ' + fmt(L, unit) + ' x ' + fmt(W, unit) + ' x ' + fmt(D, unit) + ' deep. Which liner size do I need?') + '" target="_blank" rel="noopener">Send us your sizes on WhatsApp</a>.</p>';
        out.innerHTML = head(needA, needB, area, litres) + html + note;
      }).catch(function () {
        out.innerHTML = head(needA, needB, area, litres) +
          '<p class="plx-calc__msg">Order a liner of at least this size. <a href="/collections/pond-liners">Browse all pond liners</a> or call <a href="tel:+441282270214">01282 270214</a>.</p>';
      });
    }

    function head(a, b, area, litres) {
      return '<div class="plx-calc__need"><div><small>Minimum liner size</small><b>' + fmt(a, unit) + ' × ' + fmt(b, unit) + '</b></div>' +
        '<span>' + area.toFixed(1) + ' m² of liner<br>up to ' + litres.toLocaleString('en-GB') + ' litres</span></div>';
    }
  }

  function boot() { document.querySelectorAll('[data-plx-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
